import * as Api from "./api";
import { showError } from "actions/actionCreators/snackbarActions";
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from "actions/actionCreators/httpActions";
import * as types from "./actionTypes";
import * as eventTypes from "./eventTypes";
import { getIncomeDataIsLoaded, getIncomeTypesIsLoaded } from "./selectors";

export function loadPartnerIncomeTypes(documentId, siteId, partnerId, isAssociatedPartner) {
  return async (dispatch, getState) => {
    const isLoaded = getIncomeTypesIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      let partnerIncomeTypes = await dispatch(
        sendHttpRequest(Api.loadPartnerIncomeTypes(documentId, siteId, partnerId, isAssociatedPartner))
      );
      dispatch({ type: types.LOAD_OFFER_PARTNER_INCOME_TYPES_SUCCEEDED, payload: { partnerIncomeTypes } });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updateOfferPartnerIncomeType(data, isAssociatedPartner) {
  return async dispatch => {
    dispatch({ type: types.OFFER_PARTNER_INCOME_TYPE_UPDATE_STARTED, payload: { data } });
    try {
      let event;
      if (isAssociatedPartner) {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(
            Api.updateOfferAssociatedPartnerIncomeType(data),
            "RunningOfferCommand",
            [eventTypes.OFFER_PARTNER_INCOME_TYPE_UPDATED],
            false
          )
        );
      } else {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(
            Api.updateOfferPartnerIncomeType(data),
            "RunningOfferCommand",
            [eventTypes.OFFER_PARTNER_INCOME_TYPE_UPDATED],
            false
          )
        );
      }

      if (event.ok) {
        dispatch({ type: types.OFFER_PARTNER_INCOME_TYPE_UPDATE_SUCCEEDED, payload: { data, isAssociatedPartner } });
      } else {
        dispatch({ type: types.OFFER_PARTNER_INCOME_TYPE_UPDATE_FAILED, payload: { data, error: event } });
      }
    } catch (error) {
      dispatch({ type: types.OFFER_PARTNER_INCOME_TYPE_UPDATE_FAILED, payload: { data, error } });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadOfferPartnerIncomeData(documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner) {
  return async (dispatch, getState) => {
    let { isLoaded } = getIncomeDataIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      const partnerIncomeData = await dispatch(
        sendHttpRequest(Api.loadPartnerIncomeTypeData(documentId, siteId, partnerId, incomeTypeId))
      );
      dispatch({
        type: types.LOAD_OFFER_PARTNER_INCOME_DATA_SUCCEEDED,
        payload: { partnerIncomeData, isAssociatedPartner }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadOfferPartnerSalaryData(documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner) {
  return async (dispatch, getState) => {
    let { isLoaded } = getIncomeDataIsLoaded(getState(), partnerId);
    if (isLoaded) {
      return;
    }

    try {
      const partnerIncomeData = await dispatch(
        sendHttpRequest(Api.loadPartnerSalaryData(documentId, siteId, incomeTypeId, partnerId))
      );
      dispatch({
        type: types.LOAD_OFFER_PARTNER_INCOME_DATA_SUCCEEDED,
        payload: { partnerIncomeData, isAssociatedPartner }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadIncomeDataDetailOptions(detailId) {
  //no redux cache
  return dispatch => {
    try {
      return Api.loadIncomeDataDetailOptions(detailId);
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updatePartnerIncomeData(data, isAssociatedPartner) {
  return async dispatch => {
    try {
      dispatch({ type: types.UPDATE_OFFER_PARTNER_INCOME_DATA_STARTED, payload: { data } });

      let event;
      if (isAssociatedPartner) {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(Api.updateOfferAssociatedPartnerIncomeData(data), "RunningOfferCommand", [
            eventTypes.OFFER_PARTNER_INCOME_DATA_UPDATED
          ])
        );
      } else {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(
            Api.updatePartnerIncomeData(data),
            "RunningOfferCommand",
            [eventTypes.OFFER_PARTNER_INCOME_DATA_UPDATED],
            false
          )
        );
      }

      if (event.ok) {
        dispatch({ type: types.UPDATE_OFFER_PARTNER_INCOME_DATA_SUCCEEDED, payload: { data } });
      } else {
        dispatch({ type: types.UPDATE_OFFER_PARTNER_INCOME_DATA_FAILED, payload: { data, error: event } });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function updatePartnerSalaryData(data, isAssociatedPartner) {
  return async dispatch => {
    try {
      dispatch({ type: types.UPDATE_OFFER_PARTNER_SALARY_DATA_STARTED, payload: { data } });

      let event;
      if (isAssociatedPartner) {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(Api.updateOfferAssociatedPartnerSalaryData(data), "RunningOfferCommand", [
            eventTypes.OFFER_PARTNER_SALARY_DATA_UPDATED
          ])
        );
      } else {
        event = await dispatch(
          sendHttpCommandAndWaitForEvent(
            Api.updatePartnerSalaryData(data),
            "RunningOfferCommand",
            [eventTypes.OFFER_PARTNER_SALARY_DATA_UPDATED],
            false
          )
        );
      }

      if (event.ok) {
        dispatch({ type: types.UPDATE_OFFER_PARTNER_SALARY_DATA_SUCCEEDED, payload: { data } });
      } else {
        dispatch({ type: types.UPDATE_OFFER_PARTNER_SALARY_DATA_FAILED, payload: { data, error: event } });
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
